module.exports = __webpack_public_path__ + "media/img/annamorozova-742652fb.jpg";